module.exports = __webpack_public_path__ + "static/GlitchlessSonyax58-f443a0cb840fcd3dfeb8554faab3dfbb.png";